'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./TableCard.scss');

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta panelu - tabulky, který je na výšku 100% a má scrolovatelný pouze obsah, hlavička scrolovatelná není.
 */
// --
var TableCard = function (_AbstractReactCompone) {
    (0, _inherits3.default)(TableCard, _AbstractReactCompone);

    function TableCard() {
        (0, _classCallCheck3.default)(this, TableCard);
        return (0, _possibleConstructorReturn3.default)(this, (TableCard.__proto__ || (0, _getPrototypeOf2.default)(TableCard)).apply(this, arguments));
    }

    (0, _createClass3.default)(TableCard, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                detail = _props.detail,
                header = _props.header,
                children = _props.children,
                className = _props.className;


            var wrapperClassNames = (0, _classnames2.default)(className, "card-scrollable container-fluid card-table", {
                "card": !detail,
                "card-detail": detail
            });

            return _react2.default.createElement(
                'div',
                { className: wrapperClassNames },
                header && _react2.default.createElement(
                    'div',
                    { className: 'card-scrollable-header' },
                    header
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card-scrollable-content' },
                    children
                )
            );
        }
        // TODO [R: dokumentace]

    }]);
    return TableCard;
}(_AbstractReactComponent2.default);

TableCard.propTypes = {
    // header:
    // className:
    // detail
};
exports.default = TableCard;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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